import type { Nullable } from '../../../typescript'
import { HorizontalOrVertical } from '../entity/EntityHeading/HorizontalOrVertical.enum'
import { TilePositionXY } from './TilePositionXY.type'

/**
 * Returns true if the two positions are on the same row (horizontal) or column (vertical),
 * depending on the given orientation.
 */
export function sameRowOrColumn(
  p1: Nullable<TilePositionXY>,
  p2: Nullable<TilePositionXY>,
  orientation: HorizontalOrVertical
): boolean {
  if (!p1 || !p2) return false
  if (p1 === p2) return true

  return orientation === HorizontalOrVertical.Horizontal
    ? p1.y === p2.y
    : p1.x === p2.x
}
